import React from 'react';
import { Col, Row, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import { UploadOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { Form, Field } from 'react-final-form';
import RFFSelectField from '../../form/RFFSelect';
import FileDetector from '../../fileDetector';
import { dates, column1, column2 } from './formConfig';
import './EditOrganization.scss';

export default class EditRFQ extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string.isRequired,

      description: PropTypes.string,
      solNum: PropTypes.string,
      niin: PropTypes.string,
      partNum: PropTypes.string,
      partDesc: PropTypes.string,
      quoteDueDate: PropTypes.string,
      sampleDueDate: PropTypes.string,
      orderDueDate: PropTypes.string,
      qty: PropTypes.string,
      releaseQty: PropTypes.string,
      castingWt: PropTypes.string,
      toolingAvailable: PropTypes.string,
      sampleAvailable: PropTypes.string,
      machiningReq: PropTypes.string,
      toolingDesc: PropTypes.string,
      prefCastProc: PropTypes.string,
      secOpsReq: PropTypes.string,
      reqCastSpec: PropTypes.string,
      testingRqmts: PropTypes.string,
      comment: PropTypes.string,
      drawingNums: PropTypes.string,
      nda: PropTypes.string,
      ndaId: PropTypes.string,

      ndaList: PropTypes.array,
      attachmentsList: PropTypes.array,
      materialProcess: PropTypes.string,
    }).isRequired,
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    changeDate: PropTypes.func.isRequired,
    changeSelectValue: PropTypes.func.isRequired,
    viewPDF: PropTypes.func.isRequired,
    handleUpload: PropTypes.func.isRequired,
    fileList: PropTypes.any.isRequired,
    handleUploadChange: PropTypes.func.isRequired,
    handleAttachmentUploadChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
    attachmentFileList: PropTypes.any.isRequired,
    removeAttachments: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  getNDAList = ndaList => [
    {
      name: 'ndaId',
      label: 'NDA',
      component: RFFSelectField,
      options: this.createOptions(ndaList),
      labelCol: { md: 0 },
    },
  ];

  createOptions = arr => {
    const obj = Object.assign({}, ...arr);
    const keys = Object.keys(obj);

    const options = keys.map(key => ({ text: obj[key], value: key }));
    return options;
  };

  render() {
    const {
      onSubmit,
      initialValues,
      alertType,
      alertMessage,
      changeDate,
      changeSelectValue,
      viewPDF,
      handleUploadChange,
      fileList,
      handleUpload,
      readOnly,
      attachmentFileList,
      handleAttachmentUploadChange,
      removeAttachments,
    } = this.props;
    console.log(initialValues.attachmentsList);
    let ndaList = [];
    if (initialValues && initialValues.ndaList) {
      ndaList = this.getNDAList(initialValues.ndaList);
    }
    return (
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit }) => (
          <form className="nf-edit-rfq-form" onChange={handleSubmit}>
            <br />
            {alertMessage && <Alert color={alertType}>{alertMessage}</Alert>}
            <div className="date-wrapper">
              <div className="date-container">
                {dates.map(fieldConfig => (
                  <Field
                    key={fieldConfig.name}
                    {...fieldConfig}
                    changeDate={changeDate}
                    disabled={readOnly}
                  />
                ))}
              </div>
            </div>
            <div>
              <Row>
                <Col>
                  {column1.map(fieldConfig => (
                    <Field
                      key={fieldConfig.name}
                      {...fieldConfig}
                      changeSelectValue={changeSelectValue}
                      disabled={readOnly}
                    />
                  ))}
                </Col>
                <Col>
                  {column2.map(fieldConfig => (
                    <Field
                      key={fieldConfig.name}
                      {...fieldConfig}
                      changeSelectValue={changeSelectValue}
                      disabled={readOnly}
                    />
                  ))}
                  {/* handle RFQ SELECT FIELD  */}

                  {ndaList[0] &&
                    ndaList.map(fieldConfig => (
                      <Row className='ndaRow'>
                        <Col>
                          <Field
                            disabled={readOnly}
                            key={fieldConfig.name}
                            {...fieldConfig}
                            changeSelectValue={changeSelectValue}
                          />
                        </Col>
                        <Col>
                          <Button icon={<EyeOutlined />} primary onClick={viewPDF} className='ndaBtns'>
                            View NDA
                          </Button>

                          <Upload
                            disabled={readOnly}
                            fileList={fileList}
                            accept="application/pdf,application/vnd.ms-excel"
                            customRequest={handleUpload}
                            onChange={handleUploadChange}
                          >
                            <Button disabled={readOnly} icon={<UploadOutlined />} className='ndaBtns'>
                              Upload NDA PDF
                            </Button>
                          </Upload>

                        </Col>

                      </Row>
                    ))}


                  <Row >
                    <Col className='ndaUpload col-md-4'>Attachments</Col>
                    <Col className='ndaAttachments'>
                      <Upload
                        disabled={readOnly}
                        fileList={attachmentFileList}
                        showUploadList={{ showRemoveIcon: false }}
                        customRequest={option => {
                          handleUpload(option, 'attachment');
                        }}
                        onRemove={e => {
                          console.log(e);
                        }}
                        onChange={handleAttachmentUploadChange}
                      >
                        <Button icon={<UploadOutlined />}>
                          Upload
                        </Button>
                      </Upload>

                      <FileDetector
                        attachments={
                          initialValues.attachmentsList
                            ? Object.assign(
                              {},
                              ...initialValues.attachmentsList,
                            )
                            : null
                        }
                        icon="trash"
                        reverse
                        onClick={attachmentId => {
                          removeAttachments(attachmentId);
                        }}
                      />
                    </Col>
                  </Row>


                </Col>
              </Row>
            </div>
          </ form>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/EditRFQForm/EditRFQ.jsx